import { isNullish } from '../../Utility/Nullish';

//todo: Refactor ScheduleWidget to use Scheduler instead of this
export class ScheduleEventRefresher {
    timerHandle: number | undefined;
    schedulerIntervalAction: () => void;

    constructor(schedulerIntervalAction: () => void) {
        this.schedulerIntervalAction = schedulerIntervalAction;
    }

    startTimer(): void {
        if (!isNullish(this.timerHandle)) {
            return; // timer is already running
        }

        this.timerHandle = window.setInterval(this.schedulerIntervalAction, 60 * 1000);
        this.schedulerIntervalAction(); //call immediately, to ensure that it gets run
    }

    stopTimer(): void {
        if (isNullish(this.timerHandle)) {
            return; // timer is already stopped
        }

        clearInterval(this.timerHandle);

        this.timerHandle = undefined;
    }
}
